// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__ysxSD","truncatedText":"styles_truncatedText__5s_Fr","fullText":"styles_fullText__w5qeV","textContainer":"styles_textContainer__8T3YO"};